import { ReactNode } from 'react';

import styles from './AuthLayout.module.scss';

interface AuthLayoutProps {
    children: ReactNode;
}

const AuthLayout = ({ children }: AuthLayoutProps) => (
  <div className={styles.container}>
    <div className={styles.brand}>
      <img
        src="./images/logo.png"
        alt="Cyclomedia Logo"
        width="100%"
      />
    </div>
    <div className={styles.separator}></div>
    <div className={styles.content}>
      {children}
    </div>
  </div>
);

export default AuthLayout;
